@use '@/styles/tokens' as *;

// Figma checkbox (node 134:2331). Size/radius/fill colors come from antd
// Checkbox tokens in src/config/theme.ts; sub-pixel border and hover fill
// (inexpressible as antd tokens) live here.

.checkbox {
  :global(.ant-checkbox-inner) {
    border-width: 0.5px;
  }

  &:hover
    :global(
      .ant-checkbox:not(.ant-checkbox-checked):not(.ant-checkbox-indeterminate) .ant-checkbox-inner
    ) {
    background: $color-neutral-100;
    border-color: $color-neutral-600;
  }

  :global(.ant-checkbox-indeterminate .ant-checkbox-inner) {
    background: $color-neutral-950;
    border-color: $color-neutral-950;
  }

  :global(.ant-checkbox-indeterminate .ant-checkbox-inner::after) {
    background-color: var(--text-inverse);
  }
}
